var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronCircleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15 30c-8.286 0-15-6.714-15-15s6.714-15 15-15 15 6.714 15 15-6.714 15-15 15zm-6.89-13.972 8.196 8.196c.569.568 1.488.568 2.05 0l1.03-1.028c.568-.569.568-1.488 0-2.05l-6.146-6.146 6.145-6.145c.569-.569.569-1.488 0-2.05l-1.028-1.029c-.569-.568-1.488-.568-2.05 0l-8.197 8.196c-.569.568-.569 1.488 0 2.056z",
    fill: "#11a56a",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronCircleLeft);
export default __webpack_public_path__ + "static/media/chevron-circle-left.9ee12bb760c7010e760e0a3f2dc91525.svg";
export { ForwardRef as ReactComponent };